module.exports = __webpack_public_path__ + "img/badge30.db77a3c1.png";